package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import vreo.volt.protocol.DeviceSettings
import vreo.volt.protocol.UpdateReleaseType

import org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings.AnprDeviceSettings
import org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings.AnprDeviceUpdateReleaseType

/**
 * Convert a [AnprDeviceSettings] to a [DeviceSettings] proto message.
 */
fun AnprDeviceSettings.toDeviceSettingsProto(): DeviceSettings {
    return DeviceSettings(
        update_type = this.updateType.toUpdateReleaseTypeProto(),
        enable_device_hub_reporting = this.enableDeviceHubReporting,
    )
}

/**
 * Convert a [DeviceSettings] proto message to a [AnprDeviceSettings].
 */
fun DeviceSettings.toDeviceSettings(): AnprDeviceSettings {
    return AnprDeviceSettings(
        updateType = this.update_type.toUpdateReleaseType(),
        enableDeviceHubReporting = this.enable_device_hub_reporting
    )
}

/**
 * Convert a [AnprDeviceUpdateReleaseType] to a [UpdateReleaseType] proto message.
 */
private fun AnprDeviceUpdateReleaseType.toUpdateReleaseTypeProto(): UpdateReleaseType {
    return when (this) {
        AnprDeviceUpdateReleaseType.ALPHA -> UpdateReleaseType.ALPHA
        AnprDeviceUpdateReleaseType.BETA -> UpdateReleaseType.BETA
        AnprDeviceUpdateReleaseType.STABLE -> UpdateReleaseType.STABLE
    }
}

/**
 * Convert a [UpdateReleaseType] proto message to a [AnprDeviceUpdateReleaseType].
 */
private fun UpdateReleaseType.toUpdateReleaseType(): AnprDeviceUpdateReleaseType {
    return when (this) {
        UpdateReleaseType.ALPHA -> AnprDeviceUpdateReleaseType.ALPHA
        UpdateReleaseType.BETA -> AnprDeviceUpdateReleaseType.BETA
        UpdateReleaseType.STABLE -> AnprDeviceUpdateReleaseType.STABLE
    }
}